import React from "react";
import styles from "./ForeignPatients.module.css";
import ForeignWaves from "../../../../components/UI/ForeignWaves";
import ForeignWavesTab from "../../../../components/UI/foreign-patient/ForeignWavesTab";
import { useLocation, useNavigate } from "react-router-dom";
import useDeviceWidth from "../../../../components/device-width/UseDeviceWidth";
import { Element } from "react-scroll";
import { NavigationContext } from "../../../../App";
import { useContext } from "react";

const ForeignPatients = ({ data }) => {
  const navigate = useNavigate();
  const width = useDeviceWidth();
  const location = useLocation();
  const sessionStore = location?.pathname?.includes("/branch")
    ? "branches"
    : location?.pathname?.includes("online-consultation")
    ? "online-consultation"
    : "home";

    const { setIsBackNavigation } = useContext(NavigationContext);


  return (
    <section className={styles.section} id="foreign-patients-home">
      {/* <img
        className={styles.pattern}
        src="https://via.placeholder.com/1200x800/000000/333333?text=Pattern"
        alt="Pattern"
      /> */}
      <ForeignWaves className={styles.pattern} />
      {/* <ForeignWavesTab className={styles.patternTab} /> */}
      <img className={styles.patternTab} src="/img/patterns/foreign-top.png" />
      <img
        className={styles.patternTab2}
        src="/img/patterns/foreign-bottom.png"
      />
      <div className={styles.container}>
        <div className={styles.imageWrapper}>
          <img
            data-aos="fade-down"
            data-aos-delay="150"
            src={data?.listingItems[0]?.images[0]?.url}
            alt={data?.listingItems[0]?.images[0]?.imageTag}
          />
        </div>
        <div className={styles.content}>
          {data?.showTitle && (
            <div className={styles.titleFirst}>
              <h2
                data-aos="fade-right"
                data-aos-delay="150"
                dangerouslySetInnerHTML={{ __html: data?.title }}
              ></h2>
            </div>
          )}
          <h2
            data-aos="fade-right"
            data-aos-delay="150"
            className={styles.subtitle}
          >
            {data?.subTitle}
          </h2>
          <div className={styles.imageWrapper2}>
            <img
              className={styles.mainImage2}
              src={data?.listingItems[0]?.images[0]?.url}
              alt={data?.listingItems[0]?.images[0]?.imageTag}
              data-aos="fade-down"
              data-aos-delay="150"
            />
          </div>
          <div className={styles.descOuter}>
            <div
              data-aos="fade-right"
              data-aos-delay="150"
              className={styles.description}
              dangerouslySetInnerHTML={{
                __html: data?.listingItems[0]?.homeDescription,
              }}
            />
            {width < 1200 && (
              <button
                data-aos="fade-down"
                data-aos-delay="150"
                className={`${styles.button} bg-primary-500 primary-hover2 border-primary-500`}
                onClick={() =>{
                  const yPos = window.scrollY;
                  sessionStorage.setItem("scrollTargetY", yPos.toString());
                  sessionStorage.setItem("scrollOrigin", sessionStore); // or "branch" depending on the page
                  navigate(`/pages/${data?.listingItems[0]?.slug}`)
                  setIsBackNavigation(true)
                }
                }
              >
                Know More
              </button>
            )}
          </div>
          {/* <h4 className={styles.knowMore}>
            <p>View All</p>
            <img src="/img/icons/right-arrow-only.svg" />
          </h4> */}
          {width > 1200 && (
            <Element name="section-1">
              <button
                data-aos="fade-down"
                data-aos-delay="150"
                className={`${styles.button} bg-primary-500 primary-hover2 border-primary-500`}
                onClick={() => {
                  const yPos = window.scrollY;
                  sessionStorage.setItem("scrollTargetY", yPos.toString());
                  sessionStorage.setItem("scrollOrigin", sessionStore); // or "branch" depending on the page
                  navigate(`/pages/${data?.listingItems[0]?.slug}`);
                  setIsBackNavigation(true)
                }}
              >
                Know More
              </button>
            </Element>
          )}
        </div>
      </div>
    </section>
  );
};

export default ForeignPatients;
